module.exports = __webpack_public_path__ + "media/unipod/mechanical_services_2-c7ea07a7.jpg";